// extracted by mini-css-extract-plugin
export default {"headerContainer":"CustomHeader_headerContainer__uSbtw","username":"CustomHeader_username__5YsLl","link":"CustomHeader_link__9cIZD","linkIcon":"CustomHeader_linkIcon__vmg9s"};